import { render, staticRenderFns } from "./BaseMobileHeader.vue?vue&type=template&id=8c7735ce&scoped=true"
import script from "./BaseMobileHeader.vue?vue&type=script&lang=ts"
export * from "./BaseMobileHeader.vue?vue&type=script&lang=ts"
import style0 from "./BaseMobileHeader.vue?vue&type=style&index=0&id=8c7735ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7735ce",
  null
  
)

export default component.exports